import React from 'react';
import { loaderImg } from '../../assets/images';

const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <img src={loaderImg} alt="loader" />
  </div>
);
export default CircularProgress;
